module.exports = __webpack_public_path__ + "img/f65.52a7868a.png";